import type { CSSProperties } from 'react'

/**
 * The mark: two brackets holding a dot. A message in transit between two
 * posts, which is what the name means.
 *
 * Drawn from borders rather than an SVG so the dot can carry the same
 * `--radius-face` curve the faces do: the shape language is one language.
 *
 * Decorative by default, because it usually sits beside the word "stagepost".
 * Give it a `label` where it stands in for the name, and it becomes an image
 * with that name.
 */
export function Mark({
  size = 24,
  color = 'var(--text)',
  label,
}: {
  size?: number
  color?: string
  label?: string
}) {
  const unit = size / 24
  const bracket: CSSProperties = {
    position: 'absolute',
    top: 4 * unit,
    width: 6 * unit,
    height: 16 * unit,
  }
  const edge = `${2.2 * unit}px solid ${color}`
  const naming = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true }
  return (
    <div style={{ position: 'relative', width: size, height: size, flex: 'none' }} {...naming}>
      <div style={{ ...bracket, left: unit, borderLeft: edge, borderTop: edge, borderBottom: edge }} />
      <div style={{ ...bracket, left: 17 * unit, borderRight: edge, borderTop: edge, borderBottom: edge }} />
      <div
        style={{
          position: 'absolute',
          left: 9 * unit,
          top: 9 * unit,
          width: 6 * unit,
          height: 6 * unit,
          background: color,
          borderRadius: 'var(--radius-face)',
        }}
      />
    </div>
  )
}
